import {Pagination} from '@store/common/pagination.model';
import {GlobalStatus} from '@store/common/globalStatus.enum';
import {TableFilter, TableFilterType} from '@store/common/tableFilter.model';

export interface SuppliersFilters {
  search: string;
  tableFilters: TableFilter[];
}

export namespace SuppliersFilters {
  export const initTableFilters = () => TableFilterType.initTableFilters([
    TableFilterType.ORGANISATION_TYPOLOGY,
    TableFilterType.ORGANISATION_DOMAIN,
  ]);
}

export interface SuppliersPagination extends Pagination {
  data: Supplier[];
}

export interface SupplierUI {
  id: number;
  selected: boolean;
}

export interface Supplier {
  id: number;
  status: GlobalStatus;
  createdAt: string;
  name: string;
  email: string;
  phone: string;
  city: string;
  country: string;
}